import React from 'react';
import { css } from '@emotion/react';
import Link, { LinkProps } from '../link';
import Button, { ButtonProps, buttonStyles } from '../button';
import { colors } from '../colors';
import { borderRadius, breakpoints } from '../tokens';

export const styledPillButtonStyles = css({
    display: 'inline-block',
    transition: '0.2s',
    whiteSpace: 'nowrap',
    textDecoration: 'underline',
    textDecorationThickness: '1px',
    textUnderlineOffset: '2px',
    padding: '4px 8px',
    fontWeight: '500',
    borderRadius: borderRadius.small,
    '&:hover': {
        backgroundColor: colors.grey100,
    },
    '&:active': {
        backgroundColor: colors.grey200,
    },
    [breakpoints.tb]: {
        padding: '0',
        '&:hover': {
            backgroundColor: 'transparent',
        },
        '&:active': {
            backgroundColor: 'transparent',
        },
    },
});

const StyledPillButton = React.forwardRef<HTMLButtonElement, ButtonProps>(({
    ref: _, ...props
}, ref) => (
    <Button
        ref={ref}
        css={styledPillButtonStyles}
        {...props}
    />
));

StyledPillButton.displayName = 'StyledPillButton';

export const StyledPillButtonAsLink = React.forwardRef<HTMLAnchorElement, LinkProps>(({
    ref: _, ...props
}, ref) => (
    <Link
        ref={ref}
        css={{
            ...buttonStyles,
            ...styledPillButtonStyles,
        }}
        {...props}
    />
));

StyledPillButtonAsLink.displayName = 'StyledPillButtonAsLink';

export default StyledPillButton;
